import qs from "qs";

import CityApi from "../../services/api/City";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import ErrorMsgs from "../../constants/Errors.json";
import { getPath } from "../../utils";
import SuccessMessages from "../../constants/SucessMessages.json";

function handleError(err) {
  console.log("error in city actions:", err);
}

export const setCityList = (payload) => {
  return {
    type: ActionTypes.SET_CITY_LIST,
    payload,
  };
};

export const setCurrentPageCity = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_CITY,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_CITY_FILTERS,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_CITY,
    payload,
  };
};

export const getCityList =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let finalPayload = {
        ...pageRequest,
      };

      if (getPath(filters, "startswith.length", -1) > 0) {
        finalPayload["startswith"] = filters.startswith;
        delete filters.startswith;
      } else if (
        filters.hasOwnProperty("startswith") &&
        filters["startswith"] == ""
      ) {
        delete filters.startswith;
      }

      if (Object.keys(filters).length > 0) {
        Object.keys(filters).map((key) => {
          finalPayload[key] = [filters[key]];
        });
      }
      if (filters["city_name"]) {
        finalPayload["startswith"] = filters["city_name"];
        delete finalPayload.city_name;
      }

      const queryString = qs.stringify(finalPayload);
      dispatch(setLoader(true));
      let response = await CityApi.getCityList(queryString);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setCityList(response));
        if (Object.keys(pageRequest).length > 0) {
          dispatch(setCurrentPageCity(getPath(pageRequest, "page", 1)));
        }
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFilters(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeFilters" }));
        }
        return response;
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const createCity = (data) => async (dispatch) => {
  try {
    let finalPayload = { city: data };
    dispatch(setLoader(true));
    let response = await CityApi.createCity(finalPayload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(resetState({ state: "activeCity" }));
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.CREATION_SUCCESS,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const updateCity = (id, data) => async (dispatch) => {
  try {
    const finalPayload = {
      city: data,
    };
    dispatch(setLoader(true));
    const response = await CityApi.updateCity(id, finalPayload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(resetState({ state: "activeCity" }));
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.UPDATION_SUCCESS,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const setActiveCity = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_CITY,
    payload,
  };
};

export const getBulkCities = (cityIds) => async (dispatch) => {
  console.log(cityIds);
  try {
    var cities = [];
    dispatch(setLoader(true));
    for (const id of cityIds) {
      console.log(id);
      let finalPayload = {
        id: id,
      };
      let response = await CityApi.getCity(finalPayload);
      if (response) {
        cities = [...cities, getPath(response, "city", {})];
      }
    }
    dispatch(setLoader(false));
    return cities;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getCity = (id) => async (dispatch) => {
  try {
    let finalPayload = {
      id: id,
    };
    dispatch(setLoader(true));
    let response = await CityApi.getCity(finalPayload);
    dispatch(setLoader(false));
    if (response) {
      const cityObj = getPath(response, "city", {});
      dispatch(setActiveCity(cityObj));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
